import { a as trackDataLayerEvent } from './trackEvent-1c24ea79.js';
import camelcase from 'lodash.camelcase';

const gtmBodyTag = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NN27SHZ"
                    height="0"
                    width="0"
                    style="display:none;visibility:hidden" />`;

const gtmHeadTag = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-NN27SHZ');`;

/**
 * Sets a custom dimension that should apply to all events on a page.
 *
 * @param name -- Typically a camelcase id name, like dispensaryId, strainId, brandId, etc.
 * @param value
 */
function setGlobalCustomDimension(name, value) {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  let customDimensions = window.dataLayer.customDimensions || {};
  customDimensions[camelcase(name)] = value;
  window.dataLayer.customDimensions = customDimensions;
}

/**
 * Use this method to track a non-interaction event in Google Analytics (GA) via Google Tag Manager (GTM).
 * Non-interaction events are any events that can be triggered without direct user interaction -- usually these would be
 * above-the-fold impressions. (See https://support.google.com/analytics/answer/1033068#NonInteractionEvents for more info)
 *
 * This method is configured to send events the way our GTM setup expects to receive them and no additional setup is
 * required on your part (aside from ensuring GTM is loading on your page -- you can use Cephalopod to accomplish this:
 * https://github.com/Leafly-com/cephalopod/#query-paramaters).
 *
 * Using custom dimensions:
 * We often use custom dimensions to capture ids for objects related to a click event. For example, a user might click
 * on a strain on a dispensary's menu, and we might capture a strain id, brand id, and dispensary id for that click.
 * Custom dimensions must be configured in GA and GTM, so only certain ones are supported. Check with a GTM admin via
 * the #frontend Slack channel if you need to add a new one.
 *
 * Supported custom dimensions (camel case only):
 * brandId
 * cartId
 * dealId
 * dispensaryId
 * menuItemId
 * orderId
 * productId
 * strainId
 * userId
 *
 * How event tracking works behind the scenes:
 * Google Tag Manager (GTM) event tracking uses a global variable called "dataLayer" to record events.
 * We push all tracked events to this variable, and our GTM admins configure GTM to send these events to Google Analytics.
 * If you need to get in touch with a GTM admin, try the #frontend Slack channel first.
 * Further reading: https://developers.google.com/tag-manager/devguide#using-a-data-layer
 *
 * @param category -- Generally the name of the name of the object being tracked, e.g. Strain Tile or Dispensary Card
 * @param action -- The type of interaction, e.g. Impression or Click
 * @param label -- Often omitted, but may be used to provide additional information
 * @param customDimensions -- An object containing camel case ids relevant to the interaction, e.g. { dispensaryId: 12345, strainId: 67890 }
 */
function trackNonInteractionEvent(
  category,
  action,
  label,
  customDimensions
) {
  trackDataLayerEvent(
    "nonInteractionDataLayerEvent",
    category,
    action,
    label,
    customDimensions
  );
}

function trackUser(userId) {
  if (!userId) {
    return;
  }

  setGlobalCustomDimension("userId", userId);
  return `window.dataLayer = window.dataLayer || []; window.dataLayer.push({"userId": ${userId}});`;
}

export { gtmHeadTag as a, trackUser as b, gtmBodyTag as g, setGlobalCustomDimension as s, trackNonInteractionEvent as t };
